import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import _ from "lodash";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { formatAmount, getAllMonths, getAllYears } from "../../../../services/appService";
import { getAgenciesPartners, getAgencyCandidates, loadAgencies } from "../../../store/partner";
import { getMonthlyInvoiceAgencyCandidates, loadMonthlyInvoiceAgencyCandidates } from "../../../store/reports";
import GeneratePdf from "../../../../components/GeneratePdf";
import moment from "moment";

const AgencyInvoiceCandidate = () => {

    const years = getAllYears();
    const months = getAllMonths();

    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");

    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [rptShowHide, setRptShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);

    const [agencies, setAgencies] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [allAgenciesCandidates, setAllAgenciesCandidates] = useState([]);
    const [candidatesInvoiceRpt, setCandidatesInvoiceRpt] = useState([]);

    const agenciesPartnersSelector = useSelector(getAgenciesPartners);
    const monthlyInvoiceAgencyCandidatesSelector = useSelector(getMonthlyInvoiceAgencyCandidates);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadAgencies())
    }, []);

    useEffect(() => {
        if (agenciesPartnersSelector.length > 0) {
            setAllAgenciesCandidates(agenciesPartnersSelector);
            const list = _.unionBy(agenciesPartnersSelector, "title");
            setAgencies(list);
        }
    }, [agenciesPartnersSelector])

    const handleAgencyChange = ({ currentTarget }) => {
        const agencyCandidates = allAgenciesCandidates.filter(
            (x) => x.title === currentTarget.value
        );
        setCandidates(agencyCandidates);
    };

    const handleAgencyCandidate = async ({ currentTarget }) => {
        dispatch(loadMonthlyInvoiceAgencyCandidates(currentTarget.value));
    };

    useEffect(() => {
        setCandidatesInvoiceRpt(monthlyInvoiceAgencyCandidatesSelector);
    }, [monthlyInvoiceAgencyCandidatesSelector])

    const getAgencyMonPayTotal = () => {

        let amountT = 0;
        let paidT = 0;

        candidatesInvoiceRpt.forEach((item) => {
            const total = parseFloat(item.totalAmount) || 0;
            const paid = parseFloat(item.paidAmount) || 0;

            amountT += total;
            paidT += paid;
        });

        const dueT = amountT - paidT;

        return (
            <tr className="font-weight-bold bg-lighter">
                <td colSpan={3} className="text-right">Total</td>

                {/* Total Amount */}
                <td className="text-right">{formatAmount(amountT)}</td>

                {/* Total Paid */}
                <td className="text-right">{formatAmount(paidT)}</td>

                {/* Empty column */}
                <td></td>

                {/* Total Due */}
                <td className="text-right">{formatAmount(dueT)}</td>
            </tr>
        );
    };


    const generateAgencyReport = () => {

        const headers = [
            [
                "Year",
                "Period",
                "IPCS Invoice #",
                "Amount Due $",
                "Amount Paid $",
                "Date Paid",
                "Amount Not Paid $",
            ],
        ];

        const colData = [];

        candidatesInvoiceRpt.forEach((item) => {
            const dt = [];

            const total = parseFloat(item.totalAmount) || 0;
            const paid = parseFloat(item.paidAmount) || 0;
            const due = total - paid;

            dt.push(
                item.year,

                // Month name
                months.find((x) => x.id === item.month)?.name || "",

                // Invoice #
                item.invoiceNo,

                // Amount Due
                formatAmount(total),

                // Amount Paid
                formatAmount(paid),

                // Payment Date (formatted or empty)
                item.paymentDate
                    ? moment(item.paymentDate).format("MMM Do YYYY")
                    : "",

                // Amount Not Paid
                formatAmount(due)
            );

            colData.push(dt);
        });

        setSelectedCol(headers);
        setSelectedColData(colData);
        setPdfShowHide(true);
    };


    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const handleYearChange = ({ currentTarget }) => {
        const year = currentTarget.value;
        if (year !== "") {
            const filterData = monthlyInvoiceAgencyCandidatesSelector.filter(x => x.year === parseInt(year));
            setCandidatesInvoiceRpt(filterData);
        }
        else {
            setCandidatesInvoiceRpt(monthlyInvoiceAgencyCandidatesSelector);
        }
        setYear(year);
    }

    const handleMonthChange = ({ currentTarget }) => {
        const month = currentTarget.value;
        if (month !== "") {
            const filterData = monthlyInvoiceAgencyCandidatesSelector.
                filter(x => x.year === parseInt(year) && x.month === parseInt(month));

            setCandidatesInvoiceRpt(filterData);
        }
        else {
            setCandidatesInvoiceRpt(monthlyInvoiceAgencyCandidatesSelector);
        }
        setMonth(month);
    }

    return <>
        <div className="card shadow-none border">
            <div className="card-header text-center p-3 bg-lighter">
                <h4 className="mb-0">
                    Monthly Invoices to Client (Per
                    Candidate-Basis)
                </h4>
            </div>
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-md-4">
                        <select
                            name="agencyName"
                            id="agencyName"
                            className="form-control form-control-sm"
                            onChange={handleAgencyChange}
                        >
                            <option value="">Select Agency</option>
                            {agencies.map((item) => (
                                <option value={item.title}>
                                    {item.title}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <select
                            name="candidateId"
                            id="candidateId"
                            className="form-control form-control-sm"
                            onChange={handleAgencyCandidate}
                        >
                            <option value="">Select</option>
                            {candidates.map((item) => (
                                <option value={item.performerid}>
                                    {item.performername} {item.lastName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-1">
                        <select
                            name="year"
                            id="year"
                            className="form-control form-control-sm"
                            onChange={handleYearChange}
                            value={year}
                        >
                            <option value="">Year</option>
                            {years.map((y) => (
                                <option value={y.name}>
                                    {y.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* <div className="col-md-2">
                        <select
                            name="month"
                            id="month"
                            className="form-control form-control-sm"
                            onChange={({ currentTarget }) => setMonth(currentTarget.value)}
                            value={month}
                        >
                            <option value="">Month</option>
                            {months.map((m) => (
                                <option value={m.id}>{m.name}</option>
                            ))}
                        </select>
                    </div> */}
                    <div className="col-md-3 text-right">
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-sm btn-outline-default"
                            table="monthly_pay_agencies"
                            filename="Client_Monthly_Pay"
                            sheet="Client_Monthly_Pay"
                            buttonText="Export to Excel"
                        />
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-default"
                            onClick={generateAgencyReport}
                        >
                            Generate PDF
                        </button>
                    </div>

                    <div className="col-md-12 mt-2">
                        <div className="table-responsive">
                            <table
                                className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                id="monthly_pay_agencies"
                            >
                                <thead className="thead-light">
                                    <th>Year</th>
                                    <th>Period</th>
                                    <th>IPCS Invoice #</th>
                                    <th>Amount Due $ </th>
                                    <th>Amount Paid $</th>
                                    <th>Date Paid</th>
                                    <th>Amount Not Paid $</th>
                                    {/* <th>Year to Date $</th> */}
                                </thead>
                                <tbody>
                                    {candidatesInvoiceRpt.map((item) => (
                                        <tr key={item.invoiceNo}>

                                            {/* Year */}
                                            <td>{item.year}</td>

                                            {/* Month */}
                                            <td>{months.find((x) => x.id === item.month)?.name}</td>

                                            {/* Invoice No */}
                                            <td>{item.invoiceNo}</td>

                                            {/* Total Amount */}
                                            <td className="text-right">
                                                {item.totalAmount ? formatAmount(item.totalAmount) : ""}
                                            </td>

                                            {/* Paid Amount */}
                                            <td className="text-right">
                                                {item.paidAmount ? formatAmount(item.paidAmount) : ""}
                                            </td>

                                            {/* Payment Date */}
                                            <td>
                                                {item.paymentDate && (
                                                    <Moment format="MMM Do YYYY">{item.paymentDate}</Moment>
                                                )}
                                            </td>

                                            {/* Due Amount = total - paid */}
                                            <td className="text-right">
                                                {formatAmount(
                                                    (parseFloat(item.totalAmount) || 0) -
                                                    (parseFloat(item.paidAmount) || 0)
                                                )}
                                            </td>

                                        </tr>
                                    ))}

                                    {getAgencyMonPayTotal()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GeneratePdf
            handlepdfShowHide={handlepdfShowHide}
            pdfShowHide={pdfShowHide}
            selectedCol={selectedCol}
            selectedColData={selectedColData}
        ></GeneratePdf>
    </>
}

export default AgencyInvoiceCandidate;